(function () {
  'use strict';

  let output;

  function clearOutput() {
    while (output.hasChildNodes()) {
      output.removeChild(output.lastChild);
    }
  }

  function buildCode(email, text) {
    const a = email.split(/@/);
    let code;

    if (text) {
      code = '("' + text + '".link(url)';
    } else {
      code = 'recipient.link(url)';
    }

    return (
      '<script type="text/javascript">(function(){var user="' +
      a[0] +
      '";var domain="' +
      a[1] +
      '";var recipient=user + "\\u200b@\\u200b" + domain;var url="mailto:" + user + "@" + domain;document.write(' +
      code +
      ');}());</script>'
    );
  }

  function init() {
    const button = document.getElementById('submit');

    if (document.createElement('input').placeholder === undefined) {
      document.getElementById('label1').innerHTML =
        document.getElementById('email').placeholder;
      document.getElementById('label2').innerHTML =
        document.getElementById('linkText').placeholder;
    }

    output = document.getElementById('output');

    button.onclick = function () {
      const email = document.getElementById('email').value;
      const text = document.getElementById('linkText').value;

      // expect no more validation - garbage in, garbage out! ;-)
      if (email.match(/@/)) {
        const code = buildCode(email, text);
        const h3 = document.createElement('h3');
        const pre = document.createElement('pre');

        pre.id = 'code';

        if (h3.textContent !== undefined) {
          h3.textContent = 'Your Code';
          pre.textContent = code;
        } else {
          h3.innerText = 'Your Code';
          pre.innerText = code;
        }

        clearOutput();
        output.appendChild(h3);
        output.appendChild(pre);
      } else {
        output.innerHTML = '<div class="error">ERROR: No "@" symbol</div>';
      }

      return false;
    };
  }

  const timer = setInterval(function () {
    if (document.readyState === 'complete') {
      clearInterval(timer);
      init();
    }
  }, 10);
})();
